// extracted by mini-css-extract-plugin
export var hideEditor = "_nk-2";
export var infoIcon = "_nk-3";
export var label = "_nk-1";
export var labelContainer = "_nk-0";
export var readonlyText = "_nk-4";